<table class="mainTable" style="width: 100%">
  <tr>
    <td class="mainUpperTd">

      <mat-card class="quickView" *ngIf="showQuickView">
        <table style="width: 100%; border-collapse: collapse;margin: 0px; padding: 0px">
          <tr>
            <td style="width: 18%" >
              <div class="maher" (click)="myApp.showCharts()"></div>
            </td>
            <td style="width: 70%">
              <div >
                <mat-form-field class="search"  appearance="outline">
                  <mat-label style="padding-left: 20px;">Search by Any Available Columns</mat-label>
                  <mat-icon matPrefix ><img style="vertical-align: center;height:25px; width: 25px" src="assets/cargo_container.png" ></mat-icon>
                  <input  maxlength="30" style="padding-left: 20px;"  matInput (keyup)="applyFilter($event.target.value)"  [formControl]="search1">
                </mat-form-field>
              </div>
              <div class="lowerCaseLetters" style="font-size: 14px; padding-left: 24%">After Choosing Dates and Clicking Recalculate Charges Button - click any row to see the Daily Rates</div>
            </td>
            <td style="width: 20%" *ngIf="ipadApp">
              <div >
                <div class="lowerCaseLetters" *ngIf="this.ipadApp" (click)="returnToSearch()" style="font-size: 14px; color: #E61E00; cursor: pointer">Back To Search</div>
              </div>
            </td>
          </tr>
        </table>

        <div class="flex-item2" >
          <mat-table #table23 [dataSource]="quickViewData" multiTemplateDataRows matSort="container" >
            <ng-container matColumnDef="container" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Container</mat-header-cell>
              <mat-cell style=" padding-left: 5px;" *matCellDef="let row">{{row.container}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="iso" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">ISO</mat-header-cell>
              <mat-cell  *matCellDef="let row">{{row.iso}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="line_id" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Line Op</mat-header-cell>
              <mat-cell  *matCellDef="let row">{{row.line_id}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="vesselVoyage" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Vessel/Voyage</mat-header-cell>
              <mat-cell   *matCellDef="let row">{{row.vesselVoyage}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="fte_date_fmt" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">FTE Date</mat-header-cell>
              <mat-cell  *matCellDef="let row">{{row.fte_date_fmt}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="gDate" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">
                <a style="padding-right: 49px; padding-left: 90px">Start/End</a>
                <mat-icon matSuffix matTooltip="Apply Last Entered Date to ALL APPLICABLE DEMURRAGE records"><img  (click)="setAllDates()"  style="vertical-align: center; height: 20px; width: 20px;  padding-bottom: 2px; cursor: pointer" src="assets/copy.png" ></mat-icon>
                <mat-icon matSuffix matTooltip="Erase ALL DEMURRAGE Dates" ><img (click)="clearAllDates('S')"  style="vertical-align: center; height: 20px; width: 20px;  padding-bottom: 2px; cursor: pointer" src="assets/eraser.png" ></mat-icon>

                </mat-header-cell>


              <mat-cell   *matCellDef="let row">
                <mat-form-field class="dateGood" *ngIf="shouldShowCalendar(row)" style="display: block; font-size: 17px; font-weight: initial; width: 94%; height: 2.7vh; position: relative; font-family: almoni; left: 3px" >
                  <mat-date-range-input style="position: relative; top: -17px; width: 87%"
                    [min]="row.start_datefmt"
                    [max]="row.end_datefmt"
                    [rangePicker]="picker"
                    [dateFilter]="dateFilter"
                    (click)="setupRow(row.guaranteesArray,'STORAGE',row.start_datefmt)"

                  >
                    <input matStartDate matInput style="margin-top: 0"  [(ngModel)]="row.start_date_in"(dateChange)="emitDates($event,row)">
                    <input matEndDate   matInput [(ngModel)]="row.end_date_in" (dateChange)="emitDates($event,row)" >
                  </mat-date-range-input>
                  <mat-date-range-picker   [startAt]="row.start_datefmt"   (opened)="onOpen()"   (mousedown)="setupRow(row.guaranteesArray,'STORAGE',row.start_datefmt)" [dateClass]="dateClass()" #picker ></mat-date-range-picker>
                  <mat-datepicker-toggle    (mousedown)="setupRow(row.guaranteesArray,'STORAGE',row.start_datefmt)" matSuffix [for]="picker" style="font-size: 37px; position: relative; top: -31px; right: -10px"></mat-datepicker-toggle>
                </mat-form-field>
               <div style="display: none">
                  <div class="datepicker-footer" #datepickerFooter>

                    <table style="width: 100%; height:100%; border-top: #E61E00 solid 2px">
                      <tr >
                        <td colspan="4" class="smallerFont" style="font-weight: bolder; color: #E61E00">legend</td>
                      </tr>
                      <tr>
                        <td style="width: 5%">
                          <img style="vertical-align: center; padding-top: 3px; height: 40px; width: 40px" src="assets/guarantee.png" >
                        </td>
                        <td style="width: 30%">
                          <p class="smallerFont" style="font-weight: bolder; color: #E61E00">Guarantee</p>
                        </td>
                        <td style="width: 5%">
                          <img style="vertical-align: center; padding-top: 3px; height: 40px; width: 40px" src="assets/payment-24px.svg" >
                        </td>
                        <td style="width: 30%">
                          <p class="smallerFont" style="font-weight: bolder; color: #E61E00">Credit Card</p>
                        </td>
                      </tr>
                      <tr>
                        <td style="width: 5%">
                          <img style="vertical-align: center; padding-top: 3px; height: 40px; width: 40px" src="assets/cash.png" >
                        </td>
                        <td style="width: 30%">
                          <p class="smallerFont" style="font-weight: bolder; color: #E61E00">Prepaid</p>
                        </td>
                        <td style="width: 5%">
                          <img style="vertical-align: center; padding-top: 3px; height: 40px; width: 40px" src="assets/waiver.jpg" >
                        </td>
                        <td style="width: 30%">
                          <p class="smallerFont" style="font-weight: bolder; color: #E61E00">Waived</p>
                        </td>
                      </tr>
                    </table>

                  </div>
                </div>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="totalAmountMaher" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Maher Dem.</mat-header-cell>
              <mat-cell  *matCellDef="let row" style="color: green">{{row.demurrageBalanceDueMaher}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="totalAmountLine" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Line Op Dem.</mat-header-cell>
              <mat-cell  *matCellDef="let row" style="color: green">{{row.demurrageBalanceDueLine}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="demurrageBalanceDue" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">{{demBalCol}}</mat-header-cell>
              <mat-cell  *matCellDef="let row" style="color: green">{{row.demurrageBalanceDue}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="power_fte_date_fmt" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">{{powerFTE}}</mat-header-cell>
              <mat-cell  *matCellDef="let row">{{row.power_fte_date_fmt}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="rDate" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">
                <a style="padding-right: 49px; padding-left: 90px">Start/End</a>
                <mat-icon matSuffix matTooltip="Apply Last Entered Date to ALL APPLICABLE POWER records"><img  (click)="setAllDates()"  style="vertical-align: center; height: 20px; width: 20px;  padding-bottom: 2px; cursor: pointer" src="assets/copy.png" ></mat-icon>
                <mat-icon matSuffix matTooltip="Erase ALL POWER Dates" ><img (click)="clearAllDates('R')"  style="vertical-align: center; height: 20px; width: 20px;  padding-bottom: 2px; cursor: pointer" src="assets/eraser.png" ></mat-icon>
              </mat-header-cell>
              <mat-cell   *matCellDef="let row">

                <mat-form-field class="dateGood" *ngIf="shouldShowCalendarReefer(row)" style="display: block; font-size: 17px; font-weight: initial; width: 94%; height: 2.7vh; position: relative; font-family: almoni; left: 3px" >
                  <mat-date-range-input style="position: relative; top: -17px; width: 87%"
                    [min]="row.rstart_datefmt"
                    [max]="row.rend_datefmt"
                    [rangePicker]="picker"
                    [dateFilter]="dateFilter"
                    (click)="setupRow(row.guaranteesArray,'REEFER',row.rstart_datefmt)"
                    (dateChange)="emitDates2($event,row)"
                  >
                    <input matStartDate matInput style="margin-top: 0"  [(ngModel)]="row.start_date_in2">
                    <input matEndDate   matInput [(ngModel)]="row.end_date_in2" >
                  </mat-date-range-input>
                  <mat-datepicker [startAt]="row.rstart_datefmt"   (opened)="onOpen()"   (mousedown)="setupRow(row.guaranteesArray,'REEFER',row.start_datefmt)" [dateClass]="dateClass()" #picker  ></mat-datepicker>
                  <mat-datepicker-toggle   (mousedown)="setupRow(row.guaranteesArray,'REEFER',row.rstart_datefmt)" matSuffix [for]="picker" style="font-size: 37px; position: relative; top: -31px; right: -10px"></mat-datepicker-toggle>
                </mat-form-field>



                <div style="display: none">
                  <div class="datepicker-footer" #datepickerFooter>

                    <table style="width: 100%; height:100%; border-top: #E61E00 solid 2px">
                      <tr >
                        <td colspan="4" class="smallerFont" style="font-weight: bolder; color: #E61E00">legend</td>
                      </tr>
                      <tr>
                        <td style="width: 5%">
                          <img style="vertical-align: center; padding-top: 3px; height: 40px; width: 40px" src="assets/guarantee.png" >
                        </td>
                        <td style="width: 30%">
                          <p class="smallerFont" style="font-weight: bolder; color: #E61E00">Guarantee</p>
                        </td>
                        <td style="width: 5%">
                          <img style="vertical-align: center; padding-top: 3px; height: 40px; width: 40px" src="assets/payment-24px.svg" >
                        </td>
                        <td style="width: 30%">
                          <p class="smallerFont" style="font-weight: bolder; color: #E61E00">Credit Card</p>
                        </td>
                      </tr>
                      <tr>
                        <td style="width: 5%">
                          <img style="vertical-align: center; padding-top: 3px; height: 40px; width: 40px" src="assets/cash.png" >
                        </td>
                        <td style="width: 30%">
                          <p class="smallerFont" style="font-weight: bolder; color: #E61E00">Prepaid</p>
                        </td>
                        <td style="width: 5%">
                          <img style="vertical-align: center; padding-top: 3px; height: 40px; width: 40px" src="assets/waiver.jpg" >
                        </td>
                        <td style="width: 30%">
                          <p class="smallerFont" style="font-weight: bolder; color: #E61E00">Waived</p>
                        </td>
                      </tr>
                    </table>

                  </div>
                </div>
              </mat-cell>
            </ng-container>


            <ng-container matColumnDef="powerBalanceDue" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">{{reefBalCol}}</mat-header-cell>
              <mat-cell  *matCellDef="let row" style="color: green">{{row.powerBalanceDue}}</mat-cell>
            </ng-container>

            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
            <ng-container matColumnDef="detailExpand" [attr.aria-colspan]="qvColumns.length">
              <mat-cell class="newCell" *matCellDef="let row" >
                <div class="example-element-detail" [@detailExpand]="row == expandedElement ? 'expanded' : 'collapsed'">
                  <div class="flex-item6" style="padding-top: 5px; background-color:rgba(238,238,237,0.7); border: #E61E00 1px solid; min-width: 100%" >
                    <mat-table #table23 [dataSource]="quickViewData2" multiTemplateDataRows matSort >
                      <ng-container matColumnDef="type" >
                        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader3">Type</mat-header-cell>
                        <mat-cell *matCellDef="let row">{{row.type}}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="description" >
                        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader3">Rate Description</mat-header-cell>
                        <mat-cell *matCellDef="let row">{{row.description | titlecase}}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="quantityBilled" >
                        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader3">Days</mat-header-cell>
                        <mat-cell *matCellDef="let row">{{row.quantityBilled}}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="rate" >
                        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader3">Unit Price</mat-header-cell>
                        <mat-cell  *matCellDef="let row">{{row.rate}}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="totalAmount" >
                        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader3" style="justify-content: flex-end">Total Price</mat-header-cell>
                        <mat-cell style="justify-content: flex-end" *matCellDef="let row">{{row.totalAmount}}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="blank" >
                        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader3"></mat-header-cell>
                        <mat-cell *matCellDef="let row"></mat-cell>
                      </ng-container>
                      <mat-header-row *matHeaderRowDef="demCols; sticky: true"></mat-header-row>
                      <mat-row  *matRowDef="let row; columns: demCols;" style="min-height: 26px;background-color: rgba(238,238,237,0.7);"  ></mat-row>
                    </mat-table>
                    <div style="width: 100%; text-align: right; padding-top: 10px">
                      <p  class="grandTotal">Grand Total: {{grandTotalDisp}}</p>
                    </div>

                  </div>
                </div>
              </mat-cell>
            </ng-container>


            <mat-header-row *matHeaderRowDef="qvColumns; sticky: true"></mat-header-row>
            <mat-row   *matRowDef="let row; columns: qvColumns;" class="mat-row"
                       [class.example-expanded-row]="expandedElement === row"
                       (click)="expandThatShit(row)">

            </mat-row>
            <mat-row *matRowDef="let row; columns: ['detailExpand']" class="example-detail-row" style="min-height: 0px" ></mat-row>

          </mat-table>
          <mat-toolbar style="width: 100%; display: unset">
            <mat-toolbar-row style="width: 100%; ">
              <mat-paginator class="myPaginator"  [pageSize]="20" [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
              <div style="padding-left: 14%">
                <button mat-button  (click)="verifySelection()" class="blueButton" >Recalculate Charges</button>
              </div>
              <span style="padding-left: 1%">
                  <button mat-raised-button matTooltip="Export To Excel"  (click)="exportExcel()"><img style="height: 38px"  src="assets/excel.png" ></button>
              </span>
            </mat-toolbar-row>
          </mat-toolbar>
        </div>
        <table style="width: 100%;">
          <tr>
            <td>
              <div class="lowerCaseLetters" style="font-size: 12px; text-align: left;"> Maher Statutory Statement</div>
              <a style="font-family: almoni; font-weight: bold; font-size: 10px; text-transform: uppercase">
                As used herein, the term “Schedule” means Maher’s Terminal Schedule No. 010599, as amended and restated from time to time. The Schedule is publicly available on Maher’s website, <a href="http://www.maherterminals.com" target="_blank">www.maherterminals.com </a>, and is hereby incorporated in this Invoice by reference. The demurrage charges displayed on this Invoice are consistent with the Schedule and the rules of the Federal Maritime Commission related to marine terminal operator demurrage, including the rules contained in 46 CFR 545.5 and 46 CFR Part 541, as such rules may be applicable to Maher. In addition, the performance of Maher’s obligations with respect to the Cargo which forms the subject of this Invoice did not cause or otherwise contribute to the Demurrage charges set forth herein.
              </a>
            </td>
            <td *ngIf="myUser.role!=null && myUser.role!='LINEOP' && this.foundStorageSSL">
              <div class="lowerCaseLetters" style="font-size: 12px; text-align: left;"> Line Op Statutory Statement</div>
              <a style="font-family: almoni; font-weight: bold; font-size: 10px; text-transform: uppercase">
                AS REQUIRED BY THE OCEAN SHIPPING REFORM ACT OF 2022, PUB. LAW NO. 117-146, THE OCEAN CARRIER ASSOCIATED WITH THE SUBJECT CONTAINER(S) HAS STATED THAT: (1) ITS DEMURRAGE CHARGES AGAINST SUCH CONTAINER(S) ARE CONSISTENT WITH THE RULES OF THE FEDERAL MARITIME COMMISSION WITH RESPECT TO DEMURRAGE, AND (2) ITS PERFORMANCE DID NOT CAUSE OR OTHERWISE CONTRIBUTE TO SUCH DEMURRAGE CHARGES. THE RATES ASSESSED BY THE CARRIER ARE SPECIFIED IN THAT CARRIER’S TARIFF PUBLISHED IN ACCORDANCE WITH THE RULES OF THE FEDERAL MARITIME COMMISSION; PLEASE REFER TO THE CARRIER’S TARIFF FOR FURTHER DETAILS.
              </a>
            </td>
          </tr>
        </table>

      </mat-card>




    </td>
    <td class="mainLowerTd">
      <mat-card id="badArea" class="speech-bubble" style="padding-left: 5px; padding-right: 5px" *ngIf="ipadAppear">
        <div >
          <div class="payment" style="margin-top: 2%;"></div>
          <div class="titleFont"  style="padding-bottom: 10px; ">Import Charges Calculator </div>
          <div class="flex-item3" style="padding-top: 10px">
            <div  class="lowerCaseLetters" style="font-size: 14px; text-align: center; padding-top: 5px">Enter Up To 100 Containers</div>
            <mat-form-field  appearance="outline" class="newField" >
              <textarea class="textarea" [(ngModel)]="txtFromArea"  matInput cdkTextareaAutosize oninput="this.value = this.value.toUpperCase()"></textarea>
            </mat-form-field>
          </div>
          <div style="text-align: center">
            <div class="errorDiv2" style="text-align: center" *ngIf="submitted && didntEnterShit">Must Have 1 Container</div>
            <div class="errorDiv2" style="text-align: center"  *ngIf="submitted && noPayType">Must Choose Payment Type</div>
            <div class="errorDiv2" style="text-align: center" *ngIf="submitted && badChars">Invalid Character in {{containerNum}}</div>

          </div>
        </div>
        <mat-toolbar mat-toolbar class="toolbar2">
          <mat-toolbar-row style="justify-content: center">
            <button mat-raised-button (click)="getSearchItems()"   class="blueButton" >Search</button>
            <span class="example-fill-remaining-space3"></span>
            <button mat-raised-button   class="redButton" (click)="wipeOutSearch()" >Clear List</button>
          </mat-toolbar-row>
        </mat-toolbar>
        <div>
          <mat-form-field class="myOption2"  appearance="outline">
            <mat-label>Saved Lists</mat-label>
            <mat-select  [(value)]="savedList" >
              <mat-option style="font-weight: bold"  *ngFor="let lr of savedLists" [value]="lr.id">{{lr.description}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <mat-toolbar class="myToolbar" >
          <mat-toolbar-row style="padding-left: 14%; height: 35px" >
            <button mat-button matTooltip="retrieve your saved list" (click)="showContainersFromList()" class="upperFonts" style="color:black;  font-size: 18px "><img  src="assets/saved_search-24px.svg" ></button>
            <button mat-button matTooltip="update your saved list" (click)="updateContainerList('U')" class="upperFonts" style="color:black;  font-size: 18px "><img  src="assets/save-24px.svg" ></button>
            <button mat-button matTooltip="delete your saved list" (click)="deleteHit()" class="upperFonts" style="color:black;  font-size: 18px "><img  src="assets/delete-24px.svg" ></button>
          </mat-toolbar-row>
        </mat-toolbar>
        <mat-toolbar class="myToolbar" style="background-color: white">
          <mat-toolbar-row >
            <mat-form-field  appearance="outline" >
              <mat-label>New List</mat-label>
              <input maxlength="15" [(ngModel)]="myNewListName"  oninput="this.value = this.value.toUpperCase()" matInput/>
            </mat-form-field>
            <button mat-button matTooltip="create a new saved list" (click)="updateContainerList('I')" class="upperFonts" style="color:black;  font-size: 18px "><img  src="assets/save-24px.svg" ></button>
          </mat-toolbar-row>
          <mat-toolbar-row style="height: 26px; justify-content: center">
            <div class="errorDiv2" style="text-align: center" *ngIf="submitted && insertListExists">List Exists For This User</div>
            <div class="errorDiv2" style="text-align: center" *ngIf="submitted && insertNoConts ">List Needs At Least 1 Container</div>
            <div class="errorDiv2" style="text-align: center" *ngIf="submitted && noListName ">List Name Cannot Be Blank</div>
          </mat-toolbar-row>
        </mat-toolbar>
      </mat-card>


    </td>
  </tr>
</table>


